export enum HighlightEntityType {
    text = 'text',
    tag = 'tag',
    user = 'user',
    category = 'category',
    ticket = 'ticket',
    group = 'group',
    reply = 'reply',
    url = 'url',
    widget = 'widget',
    entraIdTenant = 'entraidtenant',
    community = 'community',
}
